import styled, { css } from "styled-components";

export const AlertBox = styled.div<{ $type: "error" | "success" | "info" }>`
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;

  ${({ $type }) =>
    $type === "error" &&
    css`
      background: #fff1f2;
      border-color: #fecdd3;
      color: #9f1239;
    `}

  ${({ $type }) =>
    $type === "success" &&
    css`
      background: #ecfdf5;
      border-color: #a7f3d0;
      color: #065f46;
    `}

  ${({ $type }) =>
    $type === "info" &&
    css`
      background: #eff6ff;
      border-color: #bfdbfe;
      color: #1e40af;
    `}
`;

export const AlertClose = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  color: inherit;
  display: inline-flex;
`;
